<style lang="scss">
.btn-social-connect {
  margin-bottom: 15px;
}

.btn-twitter {
  color: #fff;
  background-color: #3cf;
  border-color: #3cf;
}

.btn-twitter:focus, .btn-twitter.focus {
  color: #fff;
  background-color: deepskyblue;
  border-color: #0086b3;
}

.btn-twitter:hover {
  color: #fff;
  background-color: deepskyblue;
  border-color: #00b8f5;
}

.btn-youtube {
  background-color: #ff1414 !important;
  color: #fff;
  border: none !important;
}

.btn-youtube:hover {
  color: #fff;
  background-color: #f80707cf !important;
  border-color: #f80707cf !important;
}

.btn-twitter:active, .btn-twitter.active,
.btn-twitter .open > .dropdown-toggle {
  color: #fff;
  background-color: deepskyblue;
  border-color: #00b8f5;
}

.btn-twitter:active:hover, .btn-twitter:active:focus, .btn-twitter:active.focus, .btn-twitter.active:hover, .btn-twitter.active:focus, .btn-twitter.active.focus,
.btn-twitter .open > .dropdown-toggle:hover,
.btn-twitter .open > .dropdown-toggle:focus,
.btn-twitter .open > .dropdown-toggle.focus {
  color: #fff;
  background-color: #00a4db;
  border-color: #0086b3;
}

.btn-twitter:active, .btn-twitter.active,
.btn-twitter .open > .dropdown-toggle {
  background-image: none;
}

.btn-twitter.disabled:hover, .btn-twitter.disabled:focus, .btn-twitter.disabled.focus, .btn-twitter[disabled]:hover, .btn-twitter[disabled]:focus, .btn-twitter[disabled].focus,
fieldset[disabled] .btn-twitter:hover,
fieldset[disabled] .btn-twitter:focus,
fieldset[disabled] .btn-twitter.focus {
  background-color: #3cf;
  border-color: #3cf;
}

.btn-twitter .badge {
  color: #3cf;
  background-color: #fff;
}

.download-modal {
  .form-control {
    border-radius: 5px !important;
    font-family: Poppins !important;
    font-size: 12px !important;
    font-weight: 500 !important;
  }

  .md-check > i:before {
    width: 16px !important;
    height: 16px !important;
    border-radius: 3px !important;
    border: 1px solid #a7a7a7 !important;
  }

  .md-check > i:after {
    left: 6px !important;
    top: 1px !important;
    width: 5px !important;
    height: 12px !important;
  }

  .control-label {
    color: #595E63;
    font-weight: 500;
  }

  .image-media-content {
    width: 100%;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  &__buttons {
    display: grid;
    grid-auto-flow: column;
    justify-content: right;
    grid-gap: 1rem;

    &--center {
      justify-content: center;
    }

    @media (max-width: 980px) {
      grid-auto-flow: row;
      justify-content: center;
    }
  }

  .downloadable-container {
    padding-top: 5px !important;
    padding-bottom: 5px !important;
    margin-left: 0px !important;
    margin-right: 0px !important;
    margin-bottom: 30px;

    .item-media {
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.16);
      border-radius: 5px !important;
      height: 52px;
      width: 52px;
      min-width: 52px;
      /*overflow: inherit !important;*/
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .item-title {
      font-family: Poppins;
      font-weight: 400;
      font-size: 14px !important;
      background: none !important;
      text-overflow: ellipsis;
      margin-left: 10px;
    }

    .item-media-colomn {
      display: flex;
      align-items: center;
      overflow: hidden;
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }
}

@media screen and (max-width: 768px) {
  .download-modal {
    .row-buttons {
      margin-left: 0px !important;
      margin-right: 0px !important;

      .btn {
        padding: 15px 40px !important;
        width: 100% !important;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .download-modal {
    h4 {
      padding-bottom: 20px;
    }
  }
}

@media screen and (max-width: 500px) {
  .download-modal {
    .row-buttons {
      margin-left: 0px !important;
      margin-right: 0px !important;

      .btn {
        padding: 15px 40px !important;
        width: 100% !important;
      }
    }
  }
}
</style>

<template>
  <div class="download-modal modal fade" id="downloadModal" ref="download-Modal" :style="$modalBackgroundStyle">
    <a data-dismiss="modal" class="text-lg p-x modal-close-btn">×</a>
    <div class="row-col">
      <div class="p-a-lg h-v row-cell v-m">
        <div class="row">
          <div class="col-sm-12 col-xs-12 col-md-8 offset-md-2">
            <div class="row">
              <div class="row item-list item-list-sm item-list-by m-b">
                <div class="col-xs-12" v-if="downloadable">
                  <h4 class="modal-title" :style="$highlightColor">Download {{ downloadable.music.name }}</h4>
                  <template v-if="showDownloadNow">
                    <div class="download-modal__buttons download-modal__buttons--center">
                      <a :href="downloadable.exchange.url" target="_blank" class="c-button c-button--success">
                        <font-awesome-icon :icon="['fas', 'download']" class="c-button__left-icon"></font-awesome-icon>
                        Download Now</a>

                    </div>
                    <div v-if="isYoutubeExchange && !isYoutubeFollowed">
                      <p class="text-center">You can help {{ downloadable.music.user.name }} by following him on their
                        social profiles.</p>
                      <div class="download-modal__buttons download-modal__buttons--center">
                        <youtube-subscribe-button v-if="isYoutubeExchange && !isYoutubeFollowed"
                                                  @click="connectYouTube" />
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="downloadable.exchange.type == 'email'">
                      <template v-if="loggedInUser">
                        <p>To download your free version of <strong>{{ downloadable.music.name }}</strong> click
                          Download Now. You will be subscribed to {{ downloadable.music.user.name }}'s mailing list with
                          your registered name and email.</p>
                      </template>
                      <template v-else>
                        <p>To download your free version of <strong>{{ downloadable.music.name }}</strong> please enter
                          your name and email address and the download link will be emailed to you.</p>
                      </template>
                      <div class="row actions">
                        <div class="col-xs-12 col-sm-5 col-md-4">
                          <img class="image-media-content" :src="downloadable.music.image(300)">
                        </div>
                        <div class="col-xs-12 col-sm-7 col-md-8">

                          <template v-if="!loggedInUser">
                            <div class="row">
                              <div class="form-group col-xs-12">
                                <label class="control-label">Name</label>
                                <input class="form-control" type="text" v-model="name" placeholder="Name">
                              </div>

                              <div class="form-group col-xs-12">
                                <label class="control-label">Email</label>
                                <input class="form-control" type="email" v-model="email" placeholder="Email">
                              </div>
                            </div>
                          </template>

                          <div class="row">
                            <div class="form-group col-xs-12">
                              <button type="button" class="btn btn-success btn-block" @click="emailDownload"
                                      v-if="downloadable.exchange.type == 'email' && !downloadable.exchange.url">
                                <i class="fa" :class="{ 'fa-download': !loading, 'fa-spinner fa-spin': loading }"></i>
                                Get Download Link
                              </button>
                            </div>
                          </div>

                          <div class="alert alert-success" :class="{ 'alert-success': success, 'alert-danger': error }"
                               v-if="success || error">{{ message }}
                          </div>
                        </div>
                      </div>
                    </template>
                    <template v-if="isYoutubeExchange || isTwitterExchange">
                      <template v-if="loading">
                        <p class="text-center"><i class="fa fa-spinner fa-spin"></i></p>
                      </template>
                      <template v-else>
                        <div class="row downloadable-container">
                          <div class="col col-md-12 col-sm-12 col-xs-12 item-media-colomn">
                            <div class="item-media">
                              <div class="item-media-content"
                                   :style="{'background-image': 'url(' +  downloadable.music.image(50) + ')'}"></div>

                            </div>
                            <div class="item-title">
                              <template v-if="isYoutubeExchange">
                                <strong>{{ downloadable.music.user.name }}</strong> asks that you subscribe to their
                                YouTube channel.
                                <br />
                                Click “Connect & Subscribe” to follow on Youtube and get your free download!
                              </template>
                              <template v-if="isTwitterExchange">
                                To obtain the free download, please connect your twitter account and follow
                                <strong>{{ downloadable.music.user.name }}</strong>.
                              </template>
                            </div>
                          </div>
                        </div>
                        <div class="download-modal__buttons">
                          <twitter-follow-button
                              v-if="isTwitterExchange"
                              @click="connectTwitter" />
                          <youtube-subscribe-button
                              v-if="isYoutubeExchange"
                              @click="connectYouTube" />
                          <button class="c-button c-button--neutral"
                                  v-if="isYoutubeExchange"
                                  @click="dismissYouTube">
                            No Thanks, I just want my download
                          </button>
                        </div>
                      </template>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</template>
<script>
import Configure from "../../mixins/configure";
import FollowButton from "../follow-button";
import YoutubeSubscribeButton from "../youtube-subscribe-button";
import TwitterFollowButton from "../twitter-follow-button";
import FreeDownload from "../../../../shared/mixins/freedownload";

export default {
  components: { TwitterFollowButton, YoutubeSubscribeButton, FollowButton },
  mixins: [Configure, FreeDownload],
  mounted() {
    this.$store.commit("downloadModal", { modal: $(this.$el) });
  }
};
</script>
